import type { TeamDto } from '../../api/project-teams';
import type { TaskProjectDto } from '../../api/tasks';

/**
 * space-cards (2026-08-21) — **무엇이 '내 스페이스' 카드로 뜨는가** 의 단일 기준.
 *
 * ⚠ 2026-10-13 사용자 결정 「모두 보이기」 — 이제 «카드가 되는가»는 거르지 않는다(내가 속한
 *   스페이스 전부가 카드). 아래 함수는 카드에 적는 «프로젝트 수»로만 쓴다. 종전 문장은 기록으로 남긴다:
 * (종전) 진행 중(=보관되지 않은) 프로젝트가 있는 스페이스만 카드가 된다. 규칙이 ProjectHomeSpaces
 * 안에만 있으면 '내 프로젝트' 격자(ProjectHomeProjects)가 다른 기준으로 걸러 두 격자가
 * 어긋나므로, 여기로 끌어내 양쪽이 이것만 쓰게 한다.
 *
 * ⚠ 좌측 네비의 '스페이스' 목록에는 **이 필터를 쓰지 않는다.** 거기는 어디로든 건너가는
 * 이동 수단이라 진행 중인 일이 없는 스페이스도 나와야 한다(2026-08-21 확정).
 */

/** 보관되지 않은(살아 있는) 프로젝트만. */
export function liveProjects(projects: TaskProjectDto[]): TaskProjectDto[] {
  return projects.filter((p) => !p.isArchived);
}

/**
 * 그 팀이 스페이스 카드에 걸고 있는 프로젝트 수. 0 이면 카드가 되지 않는다.
 *
 * 목록 응답에 teamId 가 없는 구버전 서버에서는 팀의 projectCount 로 폴백한다
 * — 이 경우 '살아 있는 프로젝트' 를 팀별로 가릴 수 없어, 응답에 진행 중 프로젝트가
 * 하나도 없을 때만 폴백한다(부분 정보로 잘못 거르지 않기 위해).
 */
export function spaceProjectCount(team: TeamDto, live: TaskProjectDto[]): number {
  const mine = live.filter((p) => p.teamId === team.id);
  return mine.length > 0 ? mine.length : (live.length === 0 ? team.projectCount : 0);
}

